import { Box, Grid, Text } from '@cmpsr/components';

export default function DashboardHeaderXAxis() {
  return (
    <Box position="relative" top={{ base: '-28px', md: '-15px' }}>
      <Grid
        gridTemplateColumns="1fr 1fr 1fr"
        alignItems="flex-start"
        justifyContent="center"
        gap={2}
        borderTop="1px solid"
        borderColor="darkBlue"
        pt={2}
      >
        <Box>
          <Text variant="text-body-meta-regular" color="tan" textAlign="center">
            Factors decreasing your risk
          </Text>
        </Box>
        <Box>
          <Text variant="text-body-meta-regular" color="tan" textAlign="center">
            Factors increasing your risk
          </Text>
        </Box>
        <Box>
          <Text variant="text-body-meta-regular" color="tan" textAlign="center">
            Factors you can modify
          </Text>
        </Box>
      </Grid>
    </Box>
  );
}
